import { render, staticRenderFns } from "./AddEntityForm.vue?vue&type=template&id=1023ff23&"
import script from "./AddEntityForm.vue?vue&type=script&lang=js&"
export * from "./AddEntityForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports